import { Input, Component, OnInit } from '@angular/core';
import { MenuNode } from '../../menu-nav-bar.model';
import { Router } from '@angular/router';
import { navigateToOldSetup } from '../../../../shared-module/common/functions/common-helpers';

const MIDDLE_MOUSE_BUTTON = 1;

@Component({
    selector: 'menu-child-node',
    templateUrl: './menu-child-node.component.html',
    styleUrls: ['../menu-node.component.scss'],
    standalone: false
})
export class MenuChildNodeComponent implements OnInit {

  @Input('node') node: MenuNode;
  public toolTipMessage: string;
  constructor(private router: Router) { }

  ngOnInit(): void { }

  public navigate(node: MenuNode, event: MouseEvent) {
    if (!node.isDisabled) {
      if (node.isOldSetup) {
         navigateToOldSetup(node.link, event.ctrlKey);
      } else {
        event.ctrlKey ? window.open(node.link) : this.router.navigate([node.link]);
      }
    }
  }

  handleMousedown(node: MenuNode, event: MouseEvent) {
    if (!node.isDisabled && event.button === MIDDLE_MOUSE_BUTTON) {
      node.isOldSetup ? navigateToOldSetup(node.link, true) : window.open(node.link);
    }
  }
}